import { ApolloClient, InMemoryCache, split } from "@apollo/client";
import { createHttpLink } from "apollo-link-http";
import { setContext } from "apollo-link-context";
import { getMainDefinition } from "@apollo/client/utilities";
import { WebSocketLink } from "@apollo/client/link/ws";

const NEST_JS_HTTP_LINK = new createHttpLink({
  uri: process.env.REACT_APP_NEST_API_ENDPOINT_URI,
});
const HASURA_HTTP_LINK = new createHttpLink({
  uri: process.env.REACT_APP_HASURA_API_ENDPOINT_URI,
});
const MONOLITH_HTTP_LINK = new createHttpLink({
  uri: process.env.REACT_APP_MONOLITH_URL,
});
const ASSET_HTTP_LINK = new createHttpLink({
  uri: process.env.REACT_APP_ASSET_URL,
});
const USER_HTTP_LINK = new createHttpLink({
  uri: process.env.REACT_APP_USER_URL,
});

const authLink = setContext(() => {
  const jwt_token = localStorage.getItem("jwt_token");
  return {
    headers: {
      authorization: jwt_token ? `Bearer ${jwt_token}` : "",
    },
  };
});

export const nestClient = new ApolloClient({
  link: authLink.concat(NEST_JS_HTTP_LINK),
  cache: new InMemoryCache(),
});

export const monoClient = new ApolloClient({
  link: authLink.concat(MONOLITH_HTTP_LINK),
  cache: new InMemoryCache(),
});

export const userClient = new ApolloClient({
  link: authLink.concat(USER_HTTP_LINK),
  cache: new InMemoryCache(),
});

export const assetClient = new ApolloClient({
  link: authLink.concat(ASSET_HTTP_LINK),
  cache: new InMemoryCache(),
});

const hasuraWsLink = new WebSocketLink({
  uri: process.env.REACT_APP_WS_HASURA_ENDPOINT_URI,
  options: {
    reconnect: true,
    connectionParams: {
      headers: {
        authorization: localStorage.getItem("jwt_token")
          ? `Bearer ${localStorage.getItem("jwt_token")}`
          : "",
      },
    },
  },
});

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  hasuraWsLink,
  HASURA_HTTP_LINK
);
export const hasuraClient = new ApolloClient({
  link: authLink.concat(splitLink),
  cache: new InMemoryCache({
    addTypename: false,
  }),
});
export const hasuraWsClient = new ApolloClient({
  link: hasuraWsLink,
  cache: new InMemoryCache({
    addTypename: false,
  }),
});
